import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import testService from "../../../services/test.service";
import lessonService from "../../../services/lesson.service";
import ResultList from "./ResultList";
import { Box } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import StyleResultLayout from "./styles/StyleResultLayout";
import Loading from "../../helper/Loading";
import withUrlParams from "../../HOC/withUrlParams";
import withErrorMessage from "../../HOC/withErrorMessage";
import withAuth from "../../HOC/withAuth";
import i18n from "i18next";
import { useRecoilValue } from "recoil";
import { isOnlineState } from "../../../states/states";
import CustomSweetAlert from "../../helper/CustomSweetAlert";

const ResultLayout = (props) => {
    const { handleError, testCode, lessonCode, uuid, currCode, accessToken } = props;
    const [results, setResults] = useState([]);
    const [testType, setTestType] = useState(0);
    const [lessonType, setLessonType] = useState(0);
    const [seeResult, setSeeResult] = useState(0);
    const [queryDataSuccess, setQueryDataSuccess] = useState(false);
    const isOnline = useRecoilValue(isOnlineState);
    const [tryTimes, setTrytimes] = useState()


    useEffect(() => {
        queryData();

    }, []);

    const queryData = () => {
        if (testCode && isOnline) {
            testService.getTestResult(testCode, accessToken)
                .then(response => {
                    if (response.data) {

                        setQueryDataSuccess(true);
                        setResults(response.data);
                    }
                })
                .catch((error) => {
                    handleError(error, "getTestResult")
                });
            testService.testInfo(testCode, accessToken)
                .then(response => {
                    setTestType(response.data.testTypeId);
                    setSeeResult(response.data.seeResult);
                })
                .catch((error) => {
                    handleError(error, "testInfo")
                });
        }
        if (lessonCode && isOnline) {
            lessonService.getLessonResult(lessonCode, accessToken)
                .then(response => {
                    if (response.data) {
                        setQueryDataSuccess(true);
                        setResults(response.data);
                    }
                })
                .catch((error) => {
                    handleError(error, "getLessonResult")
                });
            lessonService.lessonInfo(lessonCode, accessToken)
                .then(response => {
                    setLessonType(response.data.lessonTypeId);
                    setSeeResult(response.data.seeResult);
                    setTrytimes(response.data.tryTimes)
                })
                .catch((error) => {
                    handleError(error, "lessonInfo")
                });
        }
    };

    const RenderResultPage = () => {
        const classes = StyleResultLayout();
        let history = useHistory();



        if (results && queryDataSuccess && results.length > 0) {
            return (
                <React.Fragment>
                    <ResultList results={results} seeResult={seeResult} />
                    <Box style={{ paddingBottom: 20 }}>
                        <div style={{ textAlign: 'center' }}>
                            {/* check so lan thi lai */}
                            {tryTimes > 1 ? (
                                <Button className={classes.buttonRetakeQuiz} variant="contained" type={"button"}
                                    onClick={() => {
                                        if (isOnline) {
                                            if (testCode)
                                                history.push(`/start?test_code=${testCode}&uuid=${uuid}`);
                                            else if (lessonCode)
                                                history.push(`/start?uuid=${uuid}&curr_code=${currCode}&lesson_code=${lessonCode}`);
                                            window.location.reload();
                                        }
                                    }}
                                >
                                    {testType === 2 ? i18n.t('continue_practice') :
                                        testType === 3 ? i18n.t('retest') :
                                            lessonType === 2 ? i18n.t('practice_lesson') : i18n.t('retake_test')
                                    }
                                </Button>
                            ) : ""}

                        </div>
                    </Box>
                </React.Fragment>
            );
        }
        if (results.length === 0 && queryDataSuccess) {
            return <h6 className={classes.noResult}><p>{i18n.t('no_results_yet')}.</p></h6>;
        }
        if (!isOnline) {
            return <CustomSweetAlert show={true} text={i18n.t('NO_NETWORK')} showConfirm={false} />;
        }
        return <Loading />;
    };
    return (
        <RenderResultPage />
    );
};

export default withUrlParams(withAuth(withErrorMessage(ResultLayout)));
